import { VariableIsolineSignalLine } from "../core/objects/webgl/signal/variable-isoline-signal-line";
import { VariableUniversalSignalBuffer } from "./variable-universal-signal-buffer";

export class VariableUniversalSignalLine extends VariableIsolineSignalLine {
  constructor(settings) {
    super(settings);
  }

  createBuffer(settings) {
    this.signalBuffer = new VariableUniversalSignalBuffer(settings);
  }

  loadDataFromSource() {
    this.signalBuffer.loadDataFromSource();

    this.settings.gl.bindBuffer(this.settings.gl.ARRAY_BUFFER, this.glBuffer);
    this.settings.gl.bufferSubData(this.settings.gl.ARRAY_BUFFER, 0, this.signalBuffer.pointBuffer);
  }

  resetSourceBuffer() {
    this.signalBuffer.resetSourceBuffer();
  }
}
